var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05037 11.6447C7.05037 9.09467 9.16357 7.02749 11.7703 7.02749C14.3771 7.02749 16.4903 9.09467 16.4903 11.6447C16.4903 14.1947 14.3771 16.2618 11.7703 16.2618C9.16357 16.2618 7.05037 14.1947 7.05037 11.6447ZM11.7703 6C8.58347 6 6 8.5272 6 11.6447C6 14.7621 8.58347 17.2893 11.7703 17.2893C13.1052 17.2893 14.3342 16.8459 15.3118 16.1015L17.1039 17.85C17.3093 18.0504 17.6418 18.0499 17.8467 17.8491C18.0515 17.6482 18.0511 17.3229 17.8457 17.1225L16.0793 15.3991C16.9883 14.4015 17.5407 13.0862 17.5407 11.6447C17.5407 8.5272 14.9572 6 11.7703 6Z",
    fill: "#698292",
    stroke: "#698292",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e13671a39328ebea80aee53ec659f727.svg";
export { ForwardRef as ReactComponent };